module.exports = __webpack_public_path__ + "img/hot-tranny-tube.b2b77c08.svg";